import { getDefaultProductMaintenanceDetails, getDefaultASNDetails } from '../actions/productMaintenanceActions'

// import _ from 'lodash';
const productMaintenance = {
  list: {},
  productPrices: {},
  compareProductPrices: {},
  detail: null,
  newForm: getDefaultProductMaintenanceDetails(0),
  asnForm: getDefaultASNDetails(),
  isAsnBtnLoading: false,
  isAsnDelBtnLoading: false,
  asnDetail: {},
  advancedShippingNoticeItems: [],
  advancedShippingNoticeList: [],
  asnPickupLocation: [],
  isAnsStateLoading: false,
  isMaintainencePriceLoading: false,
  isEditPriceButtonLoading: false,
  isEditProductDetailLoading: false,
  isLoading: {
    list: false,
    modal: false,
    form: false,
  },
}
const ProductMaintenanceReducer = function (state = productMaintenance, action) {
  switch (action.type) {
    case 'TOGGLE_PRODUCT_MAINTENANCE_LOADING': {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.key]: action.value,
        },
      }
    }
    case 'TOGGLE_ANS_LIST_LOADING': {
      return {
        ...state,
        isAnsStateLoading: action.value,
      }
    }
    case 'TOGGLE_ASB_BUTTON_LOADING': {
      return {
        ...state,
        isAsnBtnLoading: action.value,
      }
    }
    case 'TOGGLE_ASB_DELETE_BUTTON_LOADING': {
      return {
        ...state,
        isAsnDelBtnLoading: action.value,
      }
    }
    case 'TOGGLE_MAINTENANCE_PRICE_LOADING': {
      return {
        ...state,
        isMaintainencePriceLoading: action.value,
      }
    }

    case 'TOGGLE_EDIT_PRICE_BUTTON_LOADING': {
      return {
        ...state,
        isEditPriceButtonLoading: action.value,
      }
    }

    case 'UPDATE_PRODUCT_MAINTENANCE_LIST': {
      let newList = {}
      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.list[key], ...value }))
      return {
        ...state,
        list: {
          ...state.list,
          ...newList,
        },
      }
    }
    case 'UPDATE_PRODUCT_MAINTENANCE_LOCATION_PRICE': {
      let newList = state.productPrices
      Object.entries(newList).forEach(([key, value]) => {
        if (newList[key].BuyableID == action?.id) {
          newList[key][action?.value?.key] = action?.value?.value
        }
      })
      return {
        ...state,
        productPrices: {
          ...state.productPrices,
          ...newList,
        },
      }
    }
    case 'UPDATE_PRODUCT_MAINTENANCE_PRICE_LIST': {
      let newList = {}
      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.productPrices[key], ...value }))
      return {
        ...state,
        productPrices: {
          ...state.productPrices,
          ...newList,
        },
      }
    }
    case 'UPDATE_PRODUCT_MAINTENANCE_COMPARE_PRICE_LIST': {
      let newList = {}
      Object.entries(action.list).forEach(
        ([key, value]) => (newList[key] = { ...state.compareProductPrices[key], ...value })
      )
      return {
        ...state,
        compareProductPrices: {
          ...state.compareProductPrices,
          ...newList,
        },
      }
    }
    case 'UPDATE_PRODUCT_MAINTENANCE_DETAIL': {
      return {
        ...state,
        detail: {
          ...state.detail,
          ...action.detail,
        },
      }
    }
    case 'CHANGE_PRODUCT_MAINTENANCE_DETAIL': {
      const newDetail = {
        ...state.detail,
        [action.key]: action.value,
      }

      return {
        ...state,
        detail: newDetail,
      }
    }
    case 'CHANGE_PRODUCT_MAINTENANCE_DETAIL_BULK': {
      return {
        ...state,
        detail: {
          ...state.detail,
          ...action.values,
        },
      }
    }
    case 'UPDATE_ADVANCE_SHIPPING_DETAILS': {
      let newList = state.advancedShippingNoticeItems
      const foundIndex = newList?.findIndex((item) => item.ProductID == action?.row?.id)
      if (foundIndex != -1) {
        newList[foundIndex][action?.key] = action.value
      } else {
        newList.push({ ProductID: Number(action?.row?.id), [action?.key]: action.value })
      }
      // let finalList = newList
      return {
        ...state,
        advancedShippingNoticeItems: newList,
      }
    }

    case 'SET_ADVANCE_SHIPPING_NOTICE_ITEMS': {
      return {
        ...state,
        advancedShippingNoticeItems: action.value,
      }
    }

    case 'UPDATE_ASN_PICKUP_LOCATION': {
      return {
        ...state,
        asnPickupLocation: action.value,
      }
    }
    case 'UPDATE_ADVANCE_SHIPPING_LIST': {
      return {
        ...state,
        advancedShippingNoticeList: action.value,
      }
    }
    case 'CHANGE_THREE_PL_ASN_FORM': {
      const newDetail = {
        ...state.asnForm,
        [action.key]: action.value,
      }

      return {
        ...state,
        asnForm: newDetail,
      }
    }
    case 'RESET_THREE_PL_ASN_FORM': {
      return {
        ...state,
        asnForm: getDefaultASNDetails(),
        advancedShippingNoticeItems: [],
      }
    }

    case 'UPDATE_THREE_PL_ASN_DETAIL': {
      return {
        ...state,
        asnDetail: action.value,
      }
    }

    case 'CHANGE_THREE_PL_ASN_EDIT_DETAIL': {
      const newDetail = {
        ...state.asnDetail,
        [action.key]: action.value,
      }

      return {
        ...state,
        asnDetail: newDetail,
      }
    }

    case 'CHANGE_PRODUCT_MAINTENANCE_NEW_FORM': {
      const newDetail = {
        ...state.newForm,
        [action.key]: action.value,
      }

      return {
        ...state,
        newForm: newDetail,
      }
    }
    case 'CHANGE_PRODUCT_MAINTENANCE_NEW_FORM_BULK': {
      return {
        ...state,
        newForm: {
          ...state.newForm,
          ...action.values,
        },
      }
    }
    case 'RESET_PRODUCT_MAINTENANCE_NEW_FORM_BULK': {
      return {
        ...state,
        newForm: getDefaultProductMaintenanceDetails(0),
      }
    }
    case 'TOGGLE_EDIT_PRODUCT_DETAIL_LOADING': {
      return {
        ...state,
        isEditProductDetailLoading: action.value,
      }
    }
    default: {
      return state
    }
  }
}

export default ProductMaintenanceReducer
